import { z } from '@uturn/portal/zod';

export const MAX_MESSAGE_CHARACTERS = 8000;

export const shareLinkFormSchema = z.object({
	contactName: z.string().min(1),
	contactEmail: z.string().email(),
	message: z.string().max(MAX_MESSAGE_CHARACTERS).optional(),
});

export type ShareLinkFormInputs = z.infer<typeof shareLinkFormSchema>;
